import React from 'react';

// Das ist der Filterbutton "Nur Auswahl anzeigen"

const selectedLinesFilterButton = (props) => {

  const isSelected = (props.selectedStatus === true)

  return ( isSelected )?
    <button type="button" className="btn btn-filter btn-selected-lines-filter-selected-true" onClick={props.onClick}>
      <i className="material-icons" style={{fontSize: "inherit", verticalAlign: "inherit", marginRight: "5px"}}>check_box</i>{props.title}
    </button> :

    <button type="button" className="btn btn-filter btn-selected-lines-filter-selected-false" onClick={props.onClick}>
      <i className="material-icons" style={{fontSize: "inherit", verticalAlign: "inherit", marginRight: "5px"}}>check_box_outline_blank</i>{props.title}
    </button>

};

export default selectedLinesFilterButton;



// WEBPACK FOOTER //
// ./src/components/Shared/SelectedLinesFilterButton.js